module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activePanel) ? _c('div', {
    staticClass: "sideways-content-fold"
  }, [_c('div', {
    staticClass: "portlet light bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.updateCampaign($event)
      }
    }
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('div', {
    staticClass: "margin-bottom-20"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label no-top-padding"
  }, [_c('label', {
    staticClass: "dropdown-label-override"
  }, [_vm._v("Start On")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "format": 'MMM dd, yyyy h:mm A',
      "type": "datetime",
      "placeholder": "Select Start Date*",
      "editable": false,
      "picker-options": _vm.datepickerStartOptions
    },
    model: {
      value: (_vm.editingCampaign.start_date),
      callback: function($$v) {
        _vm.$set(_vm.editingCampaign, "start_date", $$v)
      },
      expression: "editingCampaign.start_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label no-top-padding"
  }, [_c('label', {
    staticClass: "dropdown-label-override"
  }, [_vm._v("End On")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "format": 'MMM dd, yyyy h:mm A',
      "type": "datetime",
      "placeholder": "Select End Date*",
      "editable": false,
      "picker-options": _vm.datepickerEndOptions
    },
    model: {
      value: (_vm.editingCampaign.end_date),
      callback: function($$v) {
        _vm.$set(_vm.editingCampaign, "end_date", $$v)
      },
      expression: "editingCampaign.end_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('div', {
    staticClass: "form-actions noborder invite-user-actions margin-top-40"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
    key: "edit-campaign-confirm",
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\tEdit Campaign Details\n\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f1935c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/UNOgames/EditCampaignDetails.vue
// module id = 405
// module chunks = 1